import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { FileDown, Loader2 } from "lucide-react";
import { toast } from "sonner";

export function SpecPdfButton({ model, testid, className = "" }) {
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const { data } = await api.get(`/inst/models/${model.id}/pdf`, { responseType: "blob" });
      const url = URL.createObjectURL(data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${(model.model_number || "model").replace(/[^A-Za-z0-9_.-]+/g, "_")}_spec.pdf`;
      a.click();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Could not create the spec sheet");
    } finally { setBusy(false); }
  };
  return (
    <button onClick={download} disabled={busy} data-testid={testid} title="Download spec sheet PDF"
      className={`flex items-center gap-1 hover:text-[#0F172A] disabled:opacity-60 ${className}`}>
      {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <FileDown className="h-3.5 w-3.5" />} Spec PDF
    </button>
  );
}
